<template>
	<div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
    <div class="container-fluid mt--9" style="max-width: 2000px;">
			<div class="d-flex mb-3 mb-xl-0 flex-column flex-xl-row">
        <div class="mr-3 flex-grow-1" style="min-width: 1px;">
          <!-- Datos del cliente -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header bg-transparent">
                <div class="d-flex flex-column flex-xl-row align-items-start justify-content-xl-between align-items-xl-center">
                  <div class="flex-grow-1 mb-1 mb-xl-0">
                    <div class="d-flex flex-column flex-xl-row align-items-xl-center">
                      <span class="m-0 h3">{{creditNote.CardName}}
                        <span class="text-muted m-0 h4">{{creditNote.CardCode}}</span>
                      </span>
                    </div>
                    <h4 class="text-muted m-0 d-flex align-items-center font-weight-normal">
                      <span>Nota de Crédito 
                        <span style="letter-spacing: 0.5px;">
                          #{{$route.params.DocNum}}
                        </span>
                      </span>
                      <badge v-if="creditNote.DocumentStatus === 'bost_Open'" type="primary" class="ml-2">Abierta</badge>
                      <badge v-else-if="creditNote.CancelStatus === 'csYes'" type="danger" class="ml-2">Cancelada</badge>
                      <badge v-else-if="creditNote.DocumentStatus === 'bost_Close'" type="light" class="ml-2">Cerrada</badge>

                      <badge v-if="creditNote.U_TS_ReportID" type="success" class="ml-2">Timbrada</badge>
                      <badge v-else-if="!creditNote.U_TS_ReportID" type="light" class="ml-2">Sin Timbrar</badge>
                    </h4>
                  </div>
                  <base-button
                    v-if="creditNote && creditNote.U_WebXML"
                    @click="creditNoteXML();"
                    icon="fas fa-file-code"
                    size="sm"
                    :disabled="!creditNote">
                    XML
                  </base-button>
                  <base-button 
                    v-if="creditNote.U_TS_ReportID"
                    @click="creditNotePdf();" 
                    icon="fas fa-file-pdf"
                    size="sm"
                    class="mb-1 mb-xl-0"
                    :disabled="!creditNote || downloadingCreditNote">
                    PDF
                  </base-button>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex flex-column flex-xl-row">
                  <div class="d-flex my-1">
                    <h5 class="m-0">RFC</h5>
                    <p class="text-xs pl-2 m-0"><b>{{creditNote.FederalTaxID}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-xl-4" v-if="customer.U_TS_RegFiscal && regimenes">
                    <h5 class="m-0">Régimen Fiscal</h5>
                    <p class="text-xs pl-2 m-0"><b>{{regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name}}</b></p>
                  </div>	
                  <div class="d-flex my-1 ml-xl-4">
                    <h5 class="m-0">Uso CFDI</h5>
                    <p class="text-xs pl-2 m-0"><b>{{ creditNote.U_TS_UsoCFDI40 }}</b></p>
                  </div>
                </div>
              </div>
              </div>
              <div v-else style="height: 700px; padding-top: 300px;">
                <base-loader></base-loader>
              </div>
          </div>
          <!-- Detalles de Nota de Crédito -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Detalles de Nota de Crédito</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
              <div class="row">
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{creditNote.DocumentLines[0].WarehouseCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">C. P. de Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{zipCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="creditNote.SalesPersonCode && salesPersonOptions">
                  <h5 class="m-0">Vendedor</h5>
                  <p class="text-xs pl-2 m-0"><b>{{salesPersonOptions.find(x => x.SalesEmployeeCode === creditNote.SalesPersonCode).SalesEmployeeName}}</b></p>
                </div>				
                <div class="col-md-6 col-xl-4 d-flex my-1" >
                  <h5 class="m-0">Contacto</h5>
                  <p class="text-xs pl-2 m-0 text-truncate" v-if="creditNote.ContactPersonCode && customer">
                    <b>{{customer.ContactEmployees.find(x => x.InternalCode === creditNote.ContactPersonCode).Name}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Moneda</h5>
                  <p class="text-xs pl-2 m-0"><b>{{creditNote.DocCurrency}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha contable</h5>
                  <p class="text-xs pl-2 m-0"><b>{{creditNote.DocDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha de entrega</h5>
                  <p class="text-xs pl-2 m-0"><b>{{creditNote.DocDueDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Periodicidad</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.periodicity}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Meses</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.months}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Año</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.year}}</b></p>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Tabla de artículos -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header border-0">
              <h6 class="heading-small text-muted m-0 p-0">Artículos</h6>
            </div>
              <div v-if="creditNote" class="table-responsive custom-table">
                <base-table thead-classes="thead-light" :data="creditNote.DocumentLines">
                  <template #columns>
                    <th width="5%">#</th>
                    <th width="35%" class="pl-5">Artículo</th>
                    <th width="5%" class="text-center">Pedimento</th>

                    <th width="5%" class="text-right">Rollos</th>
                    <th width="10%" class="text-right">Cantidad</th>
                    <th width="10%" >U. medida</th>
                    <th width="10%" class="text-right">Precio por unidad</th>
                    <th width="10%" class="text-right">Total</th>
                  </template>
                  <template #default="{ row }">
                    <td scope="row" width="5%">
                      {{ row.LineNum + 1}}
                    </td>
                    <td scope="row" width="35%" class="pl-5">
                      <b> {{ row.ItemCode }} </b>
                      {{ row.ItemDescription }}
                      <br>
                      <b class="text-primary">{{ row.U_SubCode }} </b>
                      <span class="text-primary">{{ row.U_SubDescription }}</span>
                    </td>
                    <td scope="row" width="5%" class="text-center text-xs">
                      {{ row.U_PedimentNum || '-'}}
                    </td>
                    <td scope="row" width="5%" class="text-right">
                      {{ row.U_Rolls }}
                    </td>
                    <td scope="row" width="10%" class="text-right">
                      {{ row.Quantity }}
                    </td>
                    <td scope="row" width="10%">
                      {{ row.MeasureUnit}}
                    </td>
                    <td scope="row" width="10%" class="text-right">
                      {{ currencyFormat(row.UnitPrice, currency.iso) }}
                    </td>
                    <td scope="row"  width="10%" class="text-right">
                      {{ currencyFormat(currency.iso === 'MXN' ? row.RowTotalSC : row.RowTotalFC, currency.iso) }}
                    </td>
                  </template>
                </base-table>
              </div>
              <div class="d-flex justify-content-end px-4 border-top py-2">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? creditNote.DocTotalSys - creditNote.VatSumSys : creditNote.DocTotalFc - creditNote.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? creditNote.VatSumSys : creditNote.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? creditNote.DocTotalSys : creditNote.DocTotalFc, currency.iso) }}
                    </td>
                  </tr>
                </table>
              </div>
          </div>
          <!-- Datos Adicionales -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Datos adicionales</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
                <div class="row">
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Referencia</h5>
                  <p class="text-xs ml-2 m-0"><b>{{creditNote.NumAtCard}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Comentarios</h5>
                  <p class="text-xs ml-2 m-0"><b>{{creditNote.Comments}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Razón de devolución</h5>
                  <p class="text-xs ml-2 m-0"><b>{{reasonReturn ? reasonReturn.Description : creditNote.U_ReasonForReturn}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Doc. Relacionado</h5>
                  <p class="text-xs ml-2 m-0"><b>{{creditNote.U_WebRefObj}} {{creditNote.U_WebRefDocNum}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Tipo de referencia</h5>
                  <p class="text-xs ml-2 m-0"><b>{{refType ? refType.Description : creditNote.U_WebRefType }}</b></p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-side-cards">
          <!-- Nota de Crédito -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0">Nota de Crédito a:</h6>
              </div>
              <div class="card-body py-2">
                <div class="d-flex mb-1 ">
                  <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                  <div class="text-xs m-0 font-weight-bold text-default">
                    <span>{{creditNote.AddressExtension.BillToStreet}} </span>
                    <span>{{creditNote.AddressExtension.BillToStreetNo}} </span>
                    <span>{{creditNote.AddressExtension.BillToBlock}}</span>
                    <br>
                    <span>{{creditNote.AddressExtension.BillToZipCode}} </span>
                    <span>{{creditNote.AddressExtension.BillToCity}} </span>
                    <span>{{creditNote.AddressExtension.BillToState}}</span>
                    <br>
                    <span>{{creditNote.AddressExtension.BillToCountry}}</span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Vía de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{creditNote.PaymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Método de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{paymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Condiciones de Pago</h5>
                  <span v-if="paymentGroup" class="text-xs m-0 ml-2">
                    {{paymentGroup.PaymentTermsGroupName}}
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="py-6">
              <base-loader></base-loader>
            </div>
          </div>
          <!-- Enviar a -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Enviar a:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                <div class="text-xs m-0 font-weight-bold text-default">
                  <span>{{creditNote.AddressExtension.ShipToStreet}} </span>
                  <span>{{creditNote.AddressExtension.ShipToStreetNo}} </span>
                  <span>{{creditNote.AddressExtension.ShipToBlock}}</span>
                  <br>
                  <span>{{creditNote.AddressExtension.ShipToZipCode}} </span>
                  <span>{{creditNote.AddressExtension.ShipToCity}} </span>
                  <span>{{creditNote.AddressExtension.ShipToState}}</span>
                  <br>
                  <span>{{creditNote.AddressExtension.ShipToCountry}}</span>
                </div>
              </div>
              <hr class="my-2">
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Método de envío</h5>
                <span v-if="shippingMethod" class="text-xs m-0 ml-2">
                  {{shippingMethod.Description}}
                </span>
              </div>
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Pago flete</h5>
                <span v-if="freightPayment" class="text-xs m-0 ml-2">
                  {{freightPayment.Description}}
                </span>
              </div>
            </div>
          </div>
          <div v-if="
            customer && 
            creditNote.U_TS_ReportID == null &&
            creditNote.CardCode !== 'C02858' &&
            (creditNote.CardCode !== 'C01100' && creditNote.NumAtCard !== 'MuestraCPM')
          "
          class="mb-2"
          >
            <base-button
              v-if="!stamping"
              @click="stampCreditNote();" 
              block
              :disabled="stamping || !canStamp"
            >
              Timbrar
            </base-button>
            <div v-if="stamping" class="flex justify-items-center w-100">
              <base-loader text="Timbrando. Espere un momento..."></base-loader>
            </div>
          </div>
        </div>
      </div>
		</div>
  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
import { getAuth } from "firebase/auth";
import currency from '@/data/currency.json';
import Formats from "@/mixins/Formats";

  export default {
    mixins: [Formats],
    components:{
      BaseLoader,
    },
    data() {
      return {
        HANA_URL: process.env.VUE_APP_HANA_URL,
        user: null,
        creditNote: null,
        docLines:[],
        customer: null,
        globalInformation: null,
        zipCode: null,
        paymentMethod: null,
        paymentGroup: null,
        needsAuthorization: false,
        authorizationKey: null,
        inputAuthKey: null,
        needsReference: false,
        importFileNum: null,
        modals:{
          complete: false,
        },
        loadingImportFileNum: false,
        balanceFavorOptions: null,
        insufficientBalanceText: null, 
        regimenes: null,
        salesPersonOptions: null,
        downloadingCreditNote: false,
        currency: null,
        refType: null,
        reasonReturn: null,
        stamping: false,
        canStamp: false,
        approvalStampEmails: [
          'brendaterrazas@canplast.com.mx',
          'estefaniasalas@canplast.com.mx',
          'idalyvillalobos@canplast.com.mx',
          'alfredoreyes@canplast.com.mx'
        ],
        shippingMethod: null,
        freightPayment: null,
      }
    },

    methods: {
      creditNoteXML(){
        let link_xml = document.createElement('a');
        link_xml.download = `Nota_credito_${this.creditNote.DocNum}.xml`;
        link_xml.href = this.creditNote.U_WebXML;
        link_xml.target = '_blank';
        document.body.appendChild(link_xml);
        link_xml.click();
        document.body.removeChild(link_xml);
      },
      creditNotePdf(){
        this.downloadingCreditNote = true;
        const json = {
          "DocCode": "RIN20015", 
          "Pairs": {
            "DocKey@": this.creditNote.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement('a');
            link.download = `Nota_credito_${this.creditNote.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          }
        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingCreditNote = false;
        });
      },
      stampCreditNote(){
        this.stamping = true;
        axios
          .post(`api/fpt/re_nc?DocEntry=${this.creditNote.DocEntry}`)
          .then((res) => {
            if(res.data.DocNum){
              this.$swal({
                title: "Nota de Crédito Timbrada",
                text: `La Nota de Crédito #${res.data.DocNum} ha sido timbrada correctamente`,
                icon: "success",
              });
              this.load();
            } else if(res.data.msg){
              this.$swal({
                title: "Error",
                text: res.data.msg,
                icon: "error",
              });
            } else {
              console.error("Error", res.data)
              this.$swal({
                title: "Error",
                text: "Ocurrió un error al timbrar la Nota de Crédito",
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.stamping = false;
          });
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD');
      },
      load(){
        this.user = getAuth().currentUser;
        this.approvalStampEmails.includes(this.user.email) ? this.canStamp = true : this.canStamp = false;
        axios.get(`api/creditNotesbyDocnum?DocNum=${this.$route.params.DocNum}`)
        .then(res => {
          console.log("CREDIT NOTE", res.data.creditNote.value[0]);
          this.creditNote = res.data.creditNote.value[0];
          this.currency = currency.find(x => x.key === this.creditNote.DocCurrency);

          this.paymentMethod = this.creditNote.PaymentMethod === '99' ? 'PPD' : 'PUE';

          axios.get(`/api/paymentsByCode?code=${this.creditNote.PaymentGroupCode}`)
          .then(res => {
            this.paymentGroup = res.data.value.find(x => x.GroupNumber === this.creditNote.PaymentGroupCode);
          }).catch(err => {
            console.error(err); 
          });
          
          axios.get(`api/warehouses/${this.creditNote.DocumentLines[0].WarehouseCode}`)
          .then(res => {
            this.zipCode = res.data.value[0].ZipCode
          }).catch(err => {
            console.error(err); 
          });

          axios.get(`/api/business_partners?card_code=${this.creditNote.CardCode}`)
          .then(res => {
            this.customer = res.data;

          }).catch(err => {
            console.error(err); 
          });

          axios.get(`/api/user_fields/WebRefType`)
          .then((res) => {
            this.refType = res.data.value[0].ValidValuesMD.find(x => x.Value === this.creditNote.U_WebRefType);
          }).catch((err) => {
            console.error(err);
          });

          axios.get(`/api/user_fields/ReasonForReturn`)
          .then((res) => {
            this.reasonReturn = res.data.value[0].ValidValuesMD.find(x => x.Value === this.creditNote.U_ReasonForReturn);
          }).catch((err) => {
            console.error(err);
          });
                  
          axios.get(`api/user_fields/ShippingMethod`)
          .then(res => {
            this.shippingMethod = res.data.value[0].ValidValuesMD.find(x => x.Value === this.creditNote.U_ShippingMethod);
          }).catch(err => {
            console.error(err); 
          });

          axios.get(`api/user_fields/FreightPayment`)
          .then(res => {
            this.freightPayment = res.data.value[0].ValidValuesMD.find(x => x.Value === this.creditNote.U_FreightPayment);
          }).catch(err => {
            console.error(err); 
          });


        }).catch(err => {
          console.error(err); 
        })

        axios.get(`/api/regimen_fiscal`)
        .then(res => { 
          this.regimenes = res.data;
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`/api/sales_persons`)
        .then((response) => {
          this.salesPersonOptions = response.data.value;
        }).catch((error) => {
          console.error(error);
        });

      }
    },
    created(){
      this.load()
    }
  }
</script>

<style scoped>
.custom-side-cards{
  min-width: 100%; 
  width: 100%;
}
@media (min-width:1200px) { 
  .custom-side-cards {
    min-width: 360px; 
    width: 360px;  
  }
}
.custom-table{
  th, td {
    padding: 12px 12px;
    
  }
  td{
    vertical-align: middle;
  }
  td:first-child, 
  th:first-child {
    padding-left: 24px; /* Ajusta el padding que quieras */
  }

  td:last-child, 
  th:last-child {
    padding-right: 24px; /* Ajusta el padding que quieras */
  }
}
</style>